

export default function isDocumentSigned({ next, store, nextMiddleware }) {

  if (store.GET_DOCUSIGN_DOCUMENT_COMPLETED) {
    return next({
      name: "insurance.payment",
    });
  }

  return nextMiddleware();
}
